import { render, staticRenderFns } from "./_footerCourses.vue?vue&type=template&id=6f78c494&"
import script from "./_footerCourses.vue?vue&type=script&lang=js&"
export * from "./_footerCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports